import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['filter', 'dropdownItem', 'input']

    insertAtCaret(text) {
        const start = this.inputTarget.selectionStart
        const end = this.inputTarget.selectionEnd
        const before = this.inputTarget.value.substring(0, start)
        const after = this.inputTarget.value.substring(end, this.inputTarget.value.length)
        this.inputTarget.value = before + text + after
        this.inputTarget.selectionStart = this.inputTarget.selectionEnd = start + text.length
    }

    insertToken(event) {
        if (this.inputTarget.disabled) {
            return
        }

        const token = event.currentTarget.textContent.trim()
        this.insertAtCaret(token)
        this.inputTarget.focus()
        this.broadcastChange()
    }

    // Dropdown has an input letting you filter the tokens
    filterTokens(event) {
        const searchText = event.target.value.toLowerCase()
        this.dropdownItemTargets.forEach((item) => {
            const itemText = item.textContent.trim().toLowerCase()
            if (itemText.includes(searchText)) {
                item.style.display = ''
            } else {
                item.style.display = 'none'
            }
        })
    }

    // Broadcast change event on input as it is not triggered by the insertAtCaret function
    broadcastChange() {
        const changeEvent = new Event('change', { bubbles: true })
        this.inputTarget.dispatchEvent(changeEvent)
    }
}
